import React, { useMemo } from "react";

import type {
    TwoUpCaptionCardBlock,
    TwoUpCaptionBlock as Value,
} from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { Themed } from "../../styles/themes";
import { SpacerBlock } from "../SpacerBlock";
import { TwoUpCaptionCard } from "./TwoUpCaptionCard";

import styles from "./index.module.scss";

export type Layout = NonNullable<Value["layout"]>;

const TwoUpCaptionCardGrid = ({
    cards,
    layout,
}: {
    cards: TwoUpCaptionCardBlock[];
    layout: Layout;
}) => {
    const gridClass =
        layout === "symmetric" ? styles.gridSymmetric : styles.gridAsymmetric;

    return (
        <div className={gridClass}>
            {cards.map((card, index) => (
                <TwoUpCaptionCard
                    key={index}
                    value={card}
                    layout={layout}
                    index={index}
                />
            ))}
        </div>
    );
};

export const TwoUpCaptionBlock = ({ value }: { value: Value }) => {
    const layout: Layout = value.layout ?? "asymmetric";

    const components = useMemo(
        () => ({
            spacer: SpacerBlock,
            cards: ({ value: cards }: { value: TwoUpCaptionCardBlock[] }) => (
                <TwoUpCaptionCardGrid cards={cards} layout={layout} />
            ),
        }),
        [layout],
    );

    if (!value.items) return <></>;

    return (
        <Themed theme={value.theme} tag="section">
            <StreamField
                tagName={React.Fragment}
                components={components}
                value={value.items}
            />
        </Themed>
    );
};
